import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserem Labrador viel viel besser. Macht weiter so!',
  author: 'Familie Weber & Charlie'
}, {
  text: 'Mein Hund hat sich schnell an das Topping gewöhnt und nach ca. 1 Woche hat sich sein Stuhl verbessert. Ich bin super zufrieden.',
  author: 'Sandra aus Berlin'
}, {
  text: 'Viele Jahre viel Geld ausgegeben. Nichts hat geholfen. Um so überraschter war ich, als schon nach 14 Tagen Besserung eintrat.',
  author: 'Martina aus München'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-12 bg-white/40 border-y border-brown/10" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <h3 className="font-handwriting text-4xl text-forest font-bold text-center mb-10" data-id="element-91">
          Das sagen andere Hundeeltern
        </h3>

        <div className="grid gap-6 md:grid-cols-1" data-id="element-92">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-paper p-6 rounded-xl shadow-sm border border-brown/5" data-id="element-93">
              <div className="flex gap-1 mb-3 text-yellow-500" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-95" />)}
              </div>
              <p className="font-serif text-gray-700 italic mb-4 text-lg" data-id="element-96">
                "{review.text}"
              </p>
              <p className="font-serif font-bold text-forest text-sm" data-id="element-97">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}